(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modal-cookie"]) return;
  try {
    
	 var setCookie = $("#popup-cookie").data("cookie");
	 var cookieDays = $("#popup-cookie").data("cookiedays");
	$("#popup-cookie").slickModals({
			// Functionality
			popupType: "delayed",
			delayTime: 1500,
			exitTopDistance: 40,
			scrollTopDistance: 400,
			setCookie: setCookie,
			cookieDays: cookieDays,
			cookieTriggerClass: "setCookie-1",
			cookieName: "slickModal-1",

			// Overlay options
			overlayBg: true,
			overlayBgColor: "rgba(0,0,0,0.0)",
			overlayTransition: "ease",
			overlayTransitionSpeed: "0.25",

			// Background effects
			bgEffect: "null",
			blurBgRadius: "2px",
			scaleBgValue: "1",

			// Window options
			windowWidth: "",
			windowHeight: "",
			windowLocation: "bottomLeft",
			windowTransition: "ease",
			windowTransitionSpeed: "1",
			windowTransitionEffect: "slideBottom",
			windowShadowOffsetX: "0",
			windowShadowOffsetY: "0",
			windowShadowBlurRadius: "10px",
			windowShadowSpreadRadius: "0",
			windowShadowColor: "rgba(0,0,0,0.3)",
			windowBackground: "rgba(255,255,255,1)",
			windowRadius: "2px",
			windowMargin: "20px",
			windowPadding: "",

			// Close and reopen button
			closeButton: "icon",
			reopenClass: "openModal",
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal"]) return;
  try {
    
 	var setCookie = $("#popup").data("cookie");
 	var cookieDays = $("#popup").data("cookiedays");
  $("#popup").slickModals({
      // Functionality
      popupType: "delayed",
      delayTime: 5000,
      exitTopDistance: 40,
      scrollTopDistance: 400,
      setCookie: setCookie,
      cookieDays: cookieDays,
      cookieTriggerClass: "setCookie-1",
      cookieName: "slickModal-1",

      // Overlay options
      overlayBg: true,
      overlayBgColor: "rgba(0,0,0,0.0)",
      overlayTransition: "ease",
      overlayTransitionSpeed: "0.25",

      // Background effects
      bgEffect: "null",
      blurBgRadius: "2px",
      scaleBgValue: "1",

      // Window options
      windowWidth: "",
      windowHeight: "",
      windowLocation: "bottomRight",
      windowTransition: "ease",
      windowTransitionSpeed: "1",
      windowTransitionEffect: "slideBottom",
      windowShadowOffsetX: "0",
      windowShadowOffsetY: "0",
      windowShadowBlurRadius: "10px",
      windowShadowSpreadRadius: "0",
      windowShadowColor: "rgba(0,0,0,0.3)",
      windowBackground: "rgba(255,255,255,1)",
      windowRadius: "2px",
      windowMargin: "20px",
      windowPadding: "",

      // Close and reopen button
      closeButton: "icon",
      reopenClass: "openModal",
  });

  } catch(e) { console.error(e); }
})();
})();
